import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Buffer } from "buffer";
import process from "process";
import "@/index.css";
import App from "@/App";

// Polyfill Node globals expected by @solana/web3.js and @solana/spl-token.
// Must run before any Solana module is evaluated.
if (typeof window !== "undefined") {
  window.Buffer = window.Buffer || Buffer;
  window.process = window.process || process;
  window.global = window.global || window;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
